import React from 'react'
import { Typography } from 'antd'

const { Text } = Typography

interface UnsupportedCapabilityTextProps {
    children: React.ReactNode
}

export const UnsupportedCapabilityText: React.FC<
    UnsupportedCapabilityTextProps
> = ({ children }) => (
    <Text type="secondary" style={{ color: '#8c8c8c' }}>
        {children}
    </Text>
)
